import React, { useState } from 'react'
import Modal from 'react-modal'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import Slider from 'react-slick'
import { IoMdClose } from 'react-icons/io'
import { Link } from 'gatsby'
import Img from 'gatsby-image'
import { useMediaQuery } from 'react-responsive'
import { FiChevronRight, FiChevronLeft } from 'react-icons/fi'
import Container from './styles'

function NextArrow(props) {
  const { onClick } = props
  return (
    <div className="arrow next" onClick={onClick} role="none">
      <FiChevronRight size="1.5em" />
    </div>
  )
}
function PrevArrow(props) {
  const { onClick } = props
  return (
    <div className="arrow prev" onClick={onClick} role="none">
      <FiChevronLeft size="1.5em" />
    </div>
  )
}

Modal.setAppElement('body')

const BannerSlider = ({ bannersDesktop, bannersMobile }) => {
  const isMobile = useMediaQuery({ query: '(max-device-width: 425px)' })
  const notMobile = useMediaQuery({ query: '(min-device-width: 426px)' })
  const [modalIsOpen, setIsOpen] = useState(false)
  const [modalTitle, setModalTitle] = useState('')
  const [modalEmbed, setModalEmbed] = useState('')

  const openModal = (embed, title) => {
    setModalTitle(title)
    setModalEmbed(embed)
    setIsOpen(true)
  }
  const closeModal = () => {
    setIsOpen(false)
  }

  const linkClick = (target, device) => {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'bannerClick',
      category: 'Banner',
      action: 'Click',
      label: `Banner ${device} - ${target.alt}`,
    })
  }

  const customStyles = {
    content: {
      width: '80%',
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      padding: '50px 10px 5px',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
    },
  }
  return (
    <Container>
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        style={customStyles}
        contentLabel={modalTitle}
      >
        <button type="button" onClick={closeModal}>
          <IoMdClose size="1.2em" />
        </button>
        <iframe
          title={modalTitle}
          src={`https://www.youtube.com/embed/${modalEmbed}`}
          width="100%"
          height="450"
          frameBorder="0"
          allowFullScreen
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
        />
      </Modal>
      {notMobile && (
        <Slider
          dots
          infinite
          speed={500}
          slidesToShow={1}
          slidesToScroll={1}
          nextArrow={<NextArrow />}
          prevArrow={<PrevArrow />}
        >
          {bannersDesktop.map(banner => (
            <React.Fragment key={banner.imagem.id}>
              {banner.tipo === 'image' ? (
                <>
                  {/* Checking if is a internal link to use the right component */}
                  {banner.link.charAt(0) === '/' ? (
                    <Link
                      to={banner.link}
                      onClick={e => linkClick(e.target, 'Desktop')}
                    >
                      {/* Checking if localFile exists in GraphQl to use gatsby-image component */}
                      {banner.imagem.localFile ? (
                        <Img
                          fluid={banner.imagem.localFile.childImageSharp.fluid}
                          alt={banner.imagem.altText}
                        />
                      ) : (
                        <img
                          src={banner.imagem.sourceUrl}
                          device="Desktop"
                          alt={banner.imagem.altText}
                        />
                      )}
                    </Link>
                  ) : (
                    <a
                      href={banner.link}
                      onClick={e => linkClick(e.target, 'Desktop')}
                      rel="noreferrer"
                      target="_blank"
                    >
                      {banner.imagem.localFile ? (
                        <Img
                          fluid={banner.imagem.localFile.childImageSharp.fluid}
                          alt={banner.imagem.altText}
                        />
                      ) : (
                        <img
                          src={banner.imagem.sourceUrl}
                          device="Desktop"
                          alt={banner.imagem.altText}
                        />
                      )}
                    </a>
                  )}
                </>
              ) : (
                <a
                  href={`https://www.youtube.com/watch?v=${banner.youtubeEmbedId}`}
                  onClick={e => {
                    e.preventDefault()
                    openModal(banner.youtubeEmbedId, e.target.alt)
                  }}
                >
                  {banner.imagem.localFile ? (
                    <Img
                      fluid={banner.imagem.localFile.childImageSharp.fluid}
                      device="Desktop"
                      alt={banner.imagem.altText}
                    />
                  ) : (
                    <img
                      src={banner.imagem.sourceUrl}
                      device="Desktop"
                      alt={banner.imagem.altText}
                    />
                  )}
                </a>
              )}
            </React.Fragment>
          ))}
        </Slider>
      )}
      {isMobile && (
        <Slider
          dots
          infinite
          speed={500}
          slidesToShow={1}
          slidesToScroll={1}
          nextArrow={<NextArrow />}
          prevArrow={<PrevArrow />}
        >
          {bannersMobile.map(banner => (
            <React.Fragment key={banner.imagem.id}>
              {banner.tipo === 'image' ? (
                <>
                  {banner.link.charAt(0) === '/' ? (
                    <Link
                      to={banner.link}
                      onClick={e => linkClick(e.target, 'Mobile')}
                    >
                      {banner.imagem.localFile ? (
                        <Img
                          fluid={banner.imagem.localFile.childImageSharp.fluid}
                          alt={banner.imagem.altText}
                        />
                      ) : (
                        <img
                          src={banner.imagem.sourceUrl}
                          device="Desktop"
                          alt={banner.imagem.altText}
                        />
                      )}
                    </Link>
                  ) : (
                    <a
                      href={banner.link}
                      onClick={e => linkClick(e.target, 'Mobile')}
                      target="_blank"
                      rel="noreferrer"
                    >
                      {banner.imagem.localFile ? (
                        <Img
                          fluid={banner.imagem.localFile.childImageSharp.fluid}
                          alt={banner.imagem.altText}
                        />
                      ) : (
                        <img
                          src={banner.imagem.sourceUrl}
                          device="Desktop"
                          alt={banner.imagem.altText}
                        />
                      )}
                    </a>
                  )}
                </>
              ) : (
                <a
                  href={`https://www.youtube.com/watch?v=${banner.youtubeEmbedId}`}
                  onClick={e => {
                    e.preventDefault()
                    openModal(banner.youtubeEmbedId, e.target.alt)
                  }}
                >
                  {banner.imagem.localFile ? (
                    <Img
                      fluid={banner.imagem.localFile.childImageSharp.fluid}
                      device="Mobile"
                      alt={banner.imagem.altText}
                    />
                  ) : (
                    <img
                      src={banner.imagem.sourceUrl}
                      device="Desktop"
                      alt={banner.imagem.altText}
                    />
                  )}
                </a>
              )}
            </React.Fragment>
          ))}
        </Slider>
      )}
    </Container>
  )
}

export default BannerSlider
